<template>
  <PrescriptionPage :config="config" />
</template>

<script>
import PrescriptionPage from '@/components/smallComponents/PrescriptionPage.vue'

export default {
  components: { PrescriptionPage },
  data() {
    return {
      config: {
        pageTitle: '中药开方详情',
        fetchApi: '/api/health/v2/commonPrescription',
        relRecordApi: '/api/health/v2/rela/record',
        replaceApi: '/api/health/v2/prescription/replace',
        replaceSubmitApi: '/api/health/v2/prescription/replace/submit',
        replaceResultApi: '/api/health/v1/prescription',
        showSymptoms: false,
        showGanZhi: false,
        showExtraBasicInfo: true,
        showDiagnosisInfo: true,
        showGranules: true,
        showSupplyDays: false,
        showHandmadeSummary: true,
        tabs: ['开方信息'],
        showAiButtonOnAllTabs: false,
        showGenerateOnAllPrescriptionTabs: false,
        hasShanghanTab: false,
        generateRoute: '/commonPrescriptionImage',
      },
    }
  },
}
</script>
